import ShipperOrderTableGroup from './styled';

export default ShipperOrderTableGroup;
